import React from 'react';
import SSOAuth from './shared/SSOAuth';
import SalesDashboard from './components/SalesDashboard';
import './App.css';

function App() {
  return (
    <SSOAuth>
      <div className="App">
        <SalesDashboard />
      </div>
    </SSOAuth>
  );
}

export default App;
